import React, { useEffect } from "react";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation, usePermissions } from "hooks";
import { translations } from "./translations";
import {
  PaginateGroupsState,
} from "store/ducks/settings/groups";

import { PaginatePermissionsActions } from "store/ducks/settings/permissions";

import * as S from "./styles";
import { MainContainer, Paginator, MenuSelector } from "components/shared";
import { GridGroups, FilterGroups } from "components/settings";
import { useFilters } from 'hooks/useFilters';

export const ListGroups: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();

  const { getData } = useFilters('groups');

  const { loading, pagination, data } = useSelector<
    RootStateOrAny,
    PaginateGroupsState
  >((state) => state.paginateGroups);

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    dispatch(PaginatePermissionsActions.reset());
  }, [dispatch]);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation("configuracoes")} <MenuSelector page="groups" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission("insertProfileUser") && (
            <S.ButtonMini onClick={() => history.push("/settings/groups/new")}>
              {getTranslation("novoPerfilUsuario")}
            </S.ButtonMini>
          )}
          <FilterGroups />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridGroups groups={data} />
        <Paginator
          pagination={pagination}
          settingsPage='groups'
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
